export default __webpack_public_path__ + "static/media/resume.f6b31a5a.pdf";